import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ZiLibera, ZiLiberaUpdate } from './zile-libere.interface';

@Injectable({
    providedIn: 'root'
})
export class ZileLibereService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;

    private getZileLibereUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.zileLibere.getZileLibere;
    private storeZiLiberaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.zileLibere.storeZiLibera;
    private updateZiLiberaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.zileLibere.updateZiLibera;
    private deleteZiLiberaUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.zileLibere.deleteZiLibera;

    constructor(private http: HttpClient) { }

    addZiLibera(ziLibera: ZiLibera) {
        return this.http.post(this.storeZiLiberaUrl, ziLibera, this.httpOptions);
    }

    updateZiLibera(ziLibera: ZiLiberaUpdate) {
        return this.http.put(this.updateZiLiberaUrl, ziLibera, this.httpOptions);
    }

    deleteZiLibera(id: number) {
        return this.http.delete(this.deleteZiLiberaUrl + id);
    }

    getZileLibere() {
        return this.http.get(this.getZileLibereUrl, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
